 <div class="container">
        <div class="login">
            <div class="wrapper">
            <div class="row g-0">
                <div class="col-5">
                    <div class="image-wrapper">
                    </div>
                </div>
                <div class="col-7">
                    @if(isTestServer) {
                        <div class="tst-hint">
                            <div class="wrapper">
                                <div class="row">
                                    <div class="col-12">
                                        <h3>{{'testServer.hl' |translate}}</h3>
                                        <p>{{'testServer.description' | translate}}</p>
                                        <a [href]="prdDomain" target="_blank">{{prdDomain}}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                    <div class="form-wrapper">
                        <div class="row ">
                            <div class="col-12">
                                <div class="logo-wrapper">
                                    <div class="logo"></div>
                                </div>

                            </div>
                        </div>
                        <div class="row ">
                            <div class="col-12">
                                <h2>{{'login.headline' |translate}}</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <form [formGroup]="loginForm" (ngSubmit)="login()">
                                    <div class="login-form">
                                        <div class="row">
                                            <div class="col-12">
                                                <mat-form-field>
                                                    <mat-label>{{'login.username' | translate}}</mat-label>
                                                    <input matInput type="text" formControlName="username">
                                                </mat-form-field>
                                                @if(loginForm.controls['username'].invalid && (loginForm.get('username')?.touched)) {
                                                    @if(loginForm.controls['username'].hasError('required')) {
                                                        <div class="error" id="emailRequired" role="alert">{{'error.required' | translate}}</div>
                                                    }
                                                }
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-12">
                                                <mat-form-field>
                                                    <mat-label>{{'login.password' | translate}}</mat-label>
                                                    <input matInput type="password" formControlName="password">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 align-items-center">
                                                <mat-checkbox formControlName="_remember_me">{{'login.rememberme' | translate}}</mat-checkbox>
                                            </div>
                                        </div>
                                        @if(errorMessage) {
                                            <div class="row mt-3">
                                                <div class="col-12">
                                                    <p><span class="error login-error">{{errorMessage}}</span></p>
                                                </div>
                                            </div>
                                        }
                                        <div class="row">
                                            <div class="col-12">
                                                <button mat-raised-button type="submit"  [disabled]="!loginForm.valid" class="button float-end" >{{'button.login' | translate}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="reset-pw">
                                    <span class="forgot">{{'login.forgotPassword' | translate}}</span>
                                    <a class="nav-point"  routerLink="/reset-password">{{'nav.resetPassword'| translate}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>



